import { AccommodationService } from './../../../services/accommodation.service';
import { Router } from '@angular/router';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
declare var $;
@Component({
  selector: 'app-view-accommodation',
  templateUrl: './view-accommodation.component.html',
  styleUrls: ['./view-accommodation.component.css']
})
export class ViewAccommodationComponent implements OnInit {

  @Input() accommodationRow;
  @ViewChild('modal', { static: false }) modal: ElementRef;
  @ViewChild('closeAddAccModal', { static: false })
  closeAddAccModal: ElementRef;
  accommodation:ViewAccommodation;
  rowAcc: any;
  constructor(private accommodationService: AccommodationService, private router: Router) { }

  ngOnInit() {
   
  }

  ngOnChanges(): void {
    this.accommodation = null;
    this.accommodationService
      .getAccommodation(this.accommodationRow.id)
      .subscribe(Response => {
        console.log('getAccommodation', Response);

        this.accommodation = Response.data.accommodation;

      });
  }
}

interface ViewAccommodation {
  type: string;
  name: string;
  facilities: [string];
  childrenPolicy?: string;
  City: any;
  Local: any;
  RoomTypes: [];
}